import { call, options, params } from './helpers';

export const getLocations = (payload) =>
	call(`/beta/locations${params(payload)}`);

export const getLocation = ({ id }) => call(`/beta/locations/${id}`);

export const addLocation = (payload) =>
	call(`/beta/locations`, options(payload, 'POST'));

export const editLocation = (payload) =>
	call(`/beta/locations`, options(payload, 'PUT'));

export const deleteLocation = (payload) =>
	call(`/beta/locations`, options(payload, 'DELETE'));
